export default __webpack_public_path__ + "12527aab1d89e1fe6adaed52ded804db.svg";